import { isVisible } from 'app/lib/forms/formLogic'
import { answerText, type SentPacket } from 'app/lib/forms/paperworkRecord'
import type { AnswerValue } from 'app/lib/forms/types'
import { NON_ANSWERABLE_KINDS } from 'app/lib/forms/types'

type Props = {
  packet: SentPacket
  answers: Record<string, Record<string, AnswerValue>>
}

/** What the patient submitted, read-only, in the order they answered it. */
export function PaperworkAnswers({ packet, answers }: Props) {
  const submitted = packet.forms.filter((form) => answers[form.formId])
  return (
    <div className="flex max-h-screen flex-col gap-6 overflow-y-auto p-6">
      <h2 className="text-lg font-semibold text-strong">{packet.name}</h2>
      {submitted.map((form) => {
        const formAnswers = answers[form.formId]
        const shown = form.questions.filter(
          (question) => !NON_ANSWERABLE_KINDS.includes(question.kind) && isVisible(question, formAnswers),
        )
        return (
          <section key={form.formId} className="flex flex-col gap-3">
            <h3 className="text-sm font-semibold text-strong">{form.name}</h3>
            <dl className="flex flex-col gap-3">
              {shown.map((question) => {
                const value = formAnswers[question.id]
                const signed =
                  (question.kind === `signature` || question.kind === `initials`) && typeof value === `string`
                return (
                  <div key={question.id} className="flex flex-col gap-1">
                    <dt className="text-xs text-subtle">{question.label}</dt>
                    <dd className="text-sm text-strong">
                      {signed && value ? (
                        <img
                          src={value}
                          alt={`${question.label} by the patient`}
                          className="theme-light h-20 w-auto rounded-md border border-default bg-surface"
                        />
                      ) : (
                        answerText(question, value)
                      )}
                    </dd>
                  </div>
                )
              })}
            </dl>
          </section>
        )
      })}
    </div>
  )
}
